import React from "react";
import { useParams } from "react-router";
import { CHECK_TYPE_TO_ROUTE } from "@sscs/report/constants";
import { StatusCheckLinkProps } from "@sscs/types";
import { LinkToReport } from "Components";

const StatusCheckLink = ({
  check,
  id,
  className,
}: StatusCheckLinkProps): React.JSX.Element | null => {
  const { projectName, packageName, version } = useParams();

  if (projectName && packageName && version) {
    return (
      <LinkToReport
        id={id}
        report={{
          projectName: projectName,
          packageName: packageName,
          version: version,
          isRepro: check.checkType.toLowerCase().includes("repro"),
        }}
        goToPage={CHECK_TYPE_TO_ROUTE[check.checkType]}
        className={className}
      >
        {check.link?.label}
      </LinkToReport>
    );
  }

  return null;
};

export default StatusCheckLink;
